import React, { useRef, useEffect } from "react";
import styles from "./ScrollGallery.module.scss";
import { Card } from "../Card/Card";
import { TextReveal } from "../TextReveal/TextReveal";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const ScrollGallery = (props) => {
  const { title, cards } = props;
  const containerRefs = useRef([]);
  const trackRefs = useRef([]);

  useEffect(() => {
    containerRefs.current.forEach((container, index) => {
      const track = trackRefs.current[index];

      if (!container || !track) return;

      let totalScrollWidth = track.scrollWidth - container.offsetWidth;
      let totalScrollHeight = container.offsetHeight;

      gsap.to(track, {
        x: () => -totalScrollWidth,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "center center",
          end: `+=${totalScrollHeight}`,
          scrub: 1,
          pin: true,
          anticipatePin: 1,
        },
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div
      className={styles.scrollGallery}
      ref={(el) => {
        if (el) containerRefs.current.push(el);
      }}
    >
      {title && (
        <div className={styles.eyebrowContainer}>
          <TextReveal color="secondary">
            <h3 className={`${styles.eyebrow} ja-Medium`}>{title}</h3>
          </TextReveal>
        </div>
      )}

      <div className={styles.scrollContainer}>
        <div
          className={styles.itemContainer}
          ref={(el) => {
            if (el) trackRefs.current.push(el);
          }}
        >
          <div className={styles.cardSet}>
            {cards.map((card, index) => (
              <Card
                key={index}
                subtitle={card.subtitle}
                title={card.title}
                imageSrc={card.imageSrc}
                link={card.link}
                lang={card.lang}
                extraContent={card.extraContent}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
